export const profileConstants = {
  LOAD_PROFILE: '[Profile] Load',
  LOAD_PROFILE_SUCCESS: '[Profile] Load ok',
  LOAD_PROFILE_FAILURE: '[Profile] Load ko',
  PASSWORD_UPDATED: '[Profile] Password updated',
  UPDATING_PASSWORD: '[Profile] Updating password',
  CHANGING_ROLE: '[Profile] Changing role'
}
